export default __webpack_public_path__ + "9a52af1dd3978f6b693d35e73f99949d.jpg";